import { render, staticRenderFns } from "./VRequestStep0.vue?vue&type=template&id=438e71c7&scoped=true&"
import script from "./VRequestStep0.vue?vue&type=script&lang=js&"
export * from "./VRequestStep0.vue?vue&type=script&lang=js&"
import style0 from "./VRequestStep0.vue?vue&type=style&index=0&id=438e71c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e71c7",
  null
  
)

export default component.exports